import { Hourglass, Upload } from "lucide-react"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

const COPY = {
  waiting: "You can wait for our team's outline. If you already have your own, you can upload it now under Order Details to queue your manuscript for a writer.",
  upload: "Upload your completed outline to the Customer requirements file card under Order Details to queue your manuscript for a writer.",
  action: "Order Details",
}

// The strip above the header of a book that is On Hold until its outline is
// uploaded (OrderDetailPresenter#outline_prompt). "waiting" explains the pause
// while the outline ordered with the book is still being written, and stays
// quiet: the upload is open for a customer with an outline of their own, not
// asked for. "upload" is the customer's move, so it takes the needs-you
// colour. Both lead to the Order Details card that holds the upload. Renders
// nothing otherwise.
export default function OutlinePromptStrip({ prompt, onUpload }) {
  if (prompt !== "waiting" && prompt !== "upload") return null

  const needsUpload = prompt === "upload"
  const Icon = needsUpload ? Upload : Hourglass

  return (
    <div
      role="note"
      data-testid="outline-prompt"
      className={cn(
        "mb-[14px] flex flex-wrap items-center gap-x-[11px] gap-y-2 rounded-xl border px-[18px] py-3 text-[13px] max-[560px]:px-4",
        needsUpload ? "border-needs-you/35 bg-needs-you/10 text-foreground" : "border-border bg-secondary text-muted-foreground"
      )}
    >
      <Icon className={cn("size-4 shrink-0", needsUpload ? "text-needs-you" : "text-ink-3")} strokeWidth={1.9} />
      <span className="min-w-0 flex-1">{COPY[prompt]}</span>
      <Button type="button" variant="outline" size="sm" onClick={onUpload}>
        {COPY.action}
      </Button>
    </div>
  )
}
